define('root/Podio.Comments',['require','translate','underscore','jquery','lib/jquery/jquery.elastic','jquery.lazyload','backbone','lib/Podio.Push','views/lib/Podio.Views.SubmitToggler','models/Podio.Models.User','lib/Podio.UI.FormEmbedActions','lib/Podio.UI.Tooltips','lib/Podio.UI.FlashMessage','lib/mentionsinput/PodioMentionsInput','lib/Podio.Emojis','lib/Giphys','lib/Podio.UI.Questions','lib/Podio.UI.Modal','lib/Podio.UI.Embeds','lib/Podio.Config','lib/Podio.Transport','lib/Podio.Transport.Mentions','lib/Podio.Routes','lib/Podio.UI','lib/Podio.Utils.Text','lib/Podio.Utils','lib/Podio.UI.Gifs','lib/Podio.Event.UI','lib/Podio.Event','signals'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.elastic');
  require('jquery.lazyload');

  var Backbone = require('backbone');
  var PodioPush = require('lib/Podio.Push');
  var SubmitTogglerView = require('views/lib/Podio.Views.SubmitToggler');
  var UserModel = require('models/Podio.Models.User');
  var userModel = new UserModel();
  var FormEmbedActions = require('lib/Podio.UI.FormEmbedActions');
  var Tooltips = require('lib/Podio.UI.Tooltips');
  var FlashMessage = require('lib/Podio.UI.FlashMessage');
  var PodioMentionsInput = require('lib/mentionsinput/PodioMentionsInput');
  var Emojis = require('lib/Podio.Emojis');
  var Giphys = require('lib/Giphys');

  var Questions = require('lib/Podio.UI.Questions');
  var Modal = require('lib/Podio.UI.Modal');
  var embeds = require('lib/Podio.UI.Embeds');
  var Config = require('lib/Podio.Config');
  var transport = require('lib/Podio.Transport');
  var transportMentions = require('lib/Podio.Transport.Mentions');
  var routes = require('lib/Podio.Routes');
  var podioUI = require('lib/Podio.UI');
  var textUtils = require('lib/Podio.Utils.Text');
  var podioUtils = require('lib/Podio.Utils');
  var podioGifs = require('lib/Podio.UI.Gifs');
  var KeyCodes = podioUI.KeyCodes;
  var eventUI = require('lib/Podio.Event.UI');
  var podioEvent = require('lib/Podio.Event');
  var signalsLib = require('signals');

  var isCommandKeyDown = false;

  var eventBus = _.extend({}, Backbone.Events);

  var signals = {
    onCommentInserted : new signalsLib.Signal()
  };

  function bindEvents() {
    eventBus.bind('submitToggler:toggleChanged', onCommentComposerSubmitToggleChanged);
    eventBus.bind('submitToggler:submitTriggered', onCommentComposerSubmitToggleSubmit);
  }

  function getMentionsData(mode, query, callback) {

    var spaceId = Config.on_employee_network ? Config.space_id : '';
    var req = transportMentions.getMentionsData(query, spaceId);

    req.done(function(responseData) {
      if ( responseData.data.items ) {
        callback.apply(this, [responseData.data.items]);
      }
    });
  }

  function onLikeCommentClicked(elmTarget, e) {
    var promise;
    var commentId = elmTarget.closest('.comment').data('commentId');

    Tooltips.hideAll();

    if (elmTarget.hasClass('liked')) {
      promise = transport.deleteJSON(routes.rating_path('comment', commentId, 'like', { value: 1, variant: 'stream' }));
    } else {
      promise = transport.postJSON(routes.rating_path('comment', commentId, 'like', { value: 1, variant: 'stream' }));
    }

    promise.done(function(responseData) {
      if (responseData.status === 'ok') {
        elmTarget.replaceWith(responseData.data.html);
      }
    });
  }

  function onDeleteCommentClicked(elmTarget, e) {
    Modal.showConfirm(t('Delete Comment #comments'), t('You are about to delete this comment #comments'), null, {yes: t('Yes, delete #comments'), no: t('Cancel') }, function() {
      var elmComment = elmTarget.parents('.comment:first');
      var commentId = elmComment.data('comment-id');
      transport.deleteJSON(routes.comment_path(commentId), {}, function(responseData) {
        elmTarget.closest('.comment').fadeOut('fast');
      });
    });
  }

  function onCommentFormSubmit(elmTarget, e) {
    if (!elmTarget.valid() || elmTarget.data('submitting')) {
      return;
    }

    var elmTextArea = elmTarget.find('textarea');
    var elmCommentBox = elmTarget.parents('.comment-box');
    var elmActionBox = elmCommentBox.find('.action-box');
    var elmCommentComposer = elmCommentBox.find('.comment-composer');

    elmTextArea.focus();

    var embedInfo = embeds.getCurrentEmbedInfo(elmActionBox);
    elmTarget.find('#comment_embed_id').val(embedInfo && embedInfo.embed_id);
    elmTarget.find('#comment_embed_file_id').val(embedInfo && embedInfo.selected_file_id);

    var value = elmTextArea.val();
    if (elmCommentComposer.data('mentions')) {
      value = elmTextArea.data('mentionsInput').val();
    }
    elmTarget.find('#comment_value').val(value);

    submitComment(elmTarget);
  }

  function submitComment(elmTarget) {
    elmTarget.data('submitting', true);
    elmTarget.data('submitTogglerView').disableButton();
    var elmSubmitButton = elmTarget.find('input[type=submit]');
    podioUI.disableButtonWithLoader(elmSubmitButton);

    transport.requestFromElement(elmTarget, onCommentPosted.curry(elmTarget));
  }

  function onCommentPosted(elmForm, responseData) {
    var elmTextArea = elmForm.find('textarea');
    var elmCommentBox = elmForm.parents('.comment-box');
    var elmActionBox = elmCommentBox.find('.action-box');
    var elmCommentComposer = elmCommentBox.find('.comment-composer');

    elmForm.data('submitting', false);
    elmForm.data('submitTogglerView').restoreButton();
    var elmSubmitButton = elmForm.find('input[type=submit]');
    podioUI.restoreButtonWithLoader(elmSubmitButton);

    if (responseData.status === 'ok') {
      elmTextArea.val('').trigger('input');

      if (elmCommentComposer.data('mentions')) {
        elmTextArea.data('mentionsInput').resetInput();
      }

      // Reset uploaders
      elmForm.find('input.files-hidden-input').val('');
      elmForm.find('div.upload-attachments').empty();

      // Reset embed
      FormEmbedActions.hideEmbedBox(elmActionBox);
      Questions.hideAttach(elmActionBox);
      elmForm.find('#comment_embed_id').val('');
      elmForm.find('#comment_embed_file_id').val('');

      if (responseData.data.variant === 'stream') {

        var elmStreamObject = elmForm.closest('.object');

        elmStreamObject.replaceWith(responseData.data.html);

        textUtils.initStreamShowOverflow();

        $('#stream img.lazy').lazyload();
        $('#stream img.lazy-deferred').lazyload({
          event: 'lazyDeferred'
        });

      } else {

        elmCommentBox.find('.comment_list').append(responseData.data.html);

        var elmCompactBox = $('.comment-box.compact');
        if (elmCompactBox.length) {
          elmCompactBox.find('.comment_content.collapsed').each(function() {
            setupOverflowControl($(this));
          });
        }

        // Close comment form if add comment placeholder exists
        var elmAddComment = elmCommentBox.find('.add-comment');
        if (elmAddComment.length && elmForm.is(':visible')) {
          elmForm.hide();
          elmAddComment.show();
        }
      }

      // Show message if any was returned
      if (responseData.data.message) {
        FlashMessage.show(responseData.data.message);
      }
      if (podioUtils.showFeature('gif_pause')) {
        podioGifs.pauseGifs();
      }
    } else if (responseData.error_code === 'alert.no_access.invite') {
      var message = t('{0} is not a member of {1}, for them to see your mention you must add them. #item_activity').format(_.map(responseData.data.names, _.escape), _.escape(responseData.data.space_name));

      Modal.showConfirm(t('Invite users? #item_activity'), message, null, {yes: t('Invite users #item_activity'), no: t('Cancel #item_activity')}, function() {
        // 'OK' clicked, re-submit comment
        elmForm.find('#alert_invite').val('1');

        submitComment(elmForm);
      });
    } else {
      if (!responseData.error_propagate) {
        FlashMessage.show(t('An unexpected error occured while adding your comment. Please try again. #comments'), 'error');
      }
    }
  }

  function onShowOverflowClicked(elmTarget, e) {
    elmTarget.parents('.commentcontentwrapper').find('.comment_content').removeClass('collapsed');
    elmTarget.addClass('hidden');
    if (elmTarget.attr('href') !== '#') {
      transport.requestFromElement(elmTarget);
    }
  }

  function onShowAllCommentsClick(elmTarget, e) {
    elmTarget.parents('div.comment_list').find('div.comment.hidden').show();
    elmTarget.parents('div.comment_list').find('.comment_content.collapsed').each(function() {
      setupOverflowControl($(this));
    });

    // Indicate that comments where expanded
    var elmCommentBox = elmTarget.parents('.comment-box:first');
    var elmForm = elmCommentBox.find('form');
    elmForm.prepend('<input type="hidden" name="comments_collapsed" value="false" />');

    elmTarget.remove();
    e.stopPropagation();
  }

  function onAddCommentLinkClick(elmTarget, e) {
    var elmCommentBox = elmTarget.parents('.comment-box');
    var elmCommentComposer = elmCommentBox.find('.comment-composer');

    setupCommentBox(elmCommentBox);

    var elmForms = elmCommentComposer.find('.new-comment-form');

    _.each(elmForms, function(item) {
      var elmForm = $(item);
      if (elmForm.is(':visible')) {
        elmForm.hide();
      } else {
        elmForm.parent().find('.add-comment').hide();
        elmForm.find('.form-embed-actions,input[type=submit]').hide();
        elmForm.show();
        elmForm.find('.form-embed-actions,input[type=submit]').fadeIn('slow');
        elmForm.find('textarea').focus();

        elmForm.data('submitTogglerView').refresh();

      }
    });
  }

  function setupOverflowControl(elmCommentContent) {
    if (elmCommentContent[0].offsetHeight < elmCommentContent[0].scrollHeight) {
      elmCommentContent.parents('.commentcontentwrapper').find('.overflow-control').removeClass('hidden');
    }
  }

  function setupCommentBox(elmContext) {
    var elmCommentComposer, elmTextArea, elmSubmitButton;
    var elmCompactBox;

    if (elmContext) {
      elmCommentComposer = elmContext.find('.comment-composer');
      elmCompactBox = elmContext.find('.comment-box.compact');
      elmTextArea = elmContext.find('.new-comment-form textarea');
    } else {
      elmCommentComposer = $('.comment-composer');
      elmCompactBox = $('.comment-box.compact');
      elmTextArea = $('.new-comment-form textarea');
    }

    elmCommentComposer.each(function() {
      var elmCom = $(this);

      if (!elmCom.find('form').data('submitTogglerView')) {

        var submitTogglerView = new SubmitTogglerView({
          el : elmCom.find('.composer-buttons').get(0),
          eventBus : eventBus,
          isToggled : userModel.getProperty('comment_composer_return_submit') ? true : false,
          submitButtonOptions : {
            label: t('Add comment #comments'),
            color: 'primary baby-button',
          }
        });
        submitTogglerView.render();
        elmCom.find('form').data('submitTogglerView', submitTogglerView);
      } else {
        elmCom.find('form').data('submitTogglerView').refresh();
      }

    });

    if (elmCommentComposer.data('CommentComposerInitialised')) {
      return false;
    }

    if (elmCompactBox.length) {
      elmCompactBox.find('.comment_content.collapsed').each(function() {
        setupOverflowControl($(this));
      });
    }

    if ( (elmCommentComposer.is(':hidden')) || (!elmTextArea.length || !elmCommentComposer.length) ) {
      return false;
    }

    if (elmCommentComposer.data('mentions')) {
      var elmForm = elmCommentComposer.find('form');

      var mentionsInput = new PodioMentionsInput(elmTextArea, {
        triggers: {
          '@': getMentionsData,
          ':': Emojis.load,
          '::': Giphys.load
        }
      });

      elmTextArea.data('mentionsInput', mentionsInput);

    } else {
      elmTextArea.elastic();
    }

    elmSubmitButton = elmCommentComposer.find('input[type=submit]');

    // Enable/disable submit button during upload
    FormEmbedActions.signals.onFileUploadStarted.add(onFileUploadStarted.curry(elmSubmitButton));
    FormEmbedActions.signals.onFileUploadFinished.add(onFileUploadFinished.curry(elmSubmitButton));

    elmCommentComposer.data('CommentComposerInitialised', true);
  }

  function onCommentComposerSubmitToggleSubmit(elmSubmitToggler) {
    elmSubmitToggler.parents('.comment-composer').find('form').submit();
  }

  function onCommentComposerSubmitToggleChanged(isEnabled, elmSubmitToggler) {
    var userModel = new UserModel();

    if (isEnabled) {
      userModel.setProperty('comment_composer_return_submit', true);
    } else {
      userModel.removeProperty('comment_composer_return_submit');
    }

    elmSubmitToggler.parents('.comment-composer').find('textarea').focus();
  }

  function onTextAreaKeyupAutolinking(elmTarget, e) {
    var elmCommentBox = elmTarget.parents('.comment-box');
    var elmActionBox = elmCommentBox.find('.action-box');
    FormEmbedActions.handleAutoLinking(elmActionBox, elmTarget);
  }

  function onTextAreaKeydown(elmTarget, e) {
    var elmCommentBox = elmTarget.parents('.comment-box');
    var elmActionBox = elmCommentBox.find('.action-box');

    var returnSubmit = userModel.getProperty('comment_composer_return_submit') ? true : false;
    if (
      (returnSubmit && e.keyCode === KeyCodes.Return && !e.shiftKey) ||
      (!returnSubmit && e.keyCode === KeyCodes.Return && (e.ctrlKey || e.metaKey))
    ) {

      if (!elmCommentBox.find('.submit-toggler-submit').hasClass('loader')) {
        onCommentComposerSubmitToggleSubmit(elmTarget);
      }

      e.preventDefault();

    }

  }

  function onFileUploadStarted(elmSubmitButton) {
    podioUI.disableInputField(elmSubmitButton);
  }

  function onFileUploadFinished(elmSubmitButton) {
    podioUI.restoreInputField(elmSubmitButton);
  }

  function onCommentCreatePushReceived(pushData) {
    var elmCommentList = $('.comment-box .comment_list');

    if (!elmCommentList.length) {
      return;
    }

    if (
      pushData['created_by']['type'] === 'user' &&
      pushData['created_by']['id'] === Config.user.user_id
    ) {
      return;
    }

    var commentId = pushData['ref']['id'];
    var req = transport.getJSON(routes.comment_path(commentId), {});

    req.done(function(responseData) {
      var elmNewComment = $(responseData.data.html);
      elmNewComment.hide();
      elmCommentList.append(elmNewComment);
      elmNewComment.fadeIn();
      signals.onCommentInserted.dispatch();
    });
  }

  function onDomReady() {
    if (podioUtils.showFeature('gif_pause')) {
      podioGifs.pauseGifs();
    }
    bindEvents();
  }

  podioEvent.bind(podioEvent.Types.init, onDomReady);
  eventUI.bind('submit', '.new-comment-form', onCommentFormSubmit);
  eventUI.bind('click', 'a.js-delete-comment', onDeleteCommentClicked);
  eventUI.bind('click', 'div.comment-box .add-comment', onAddCommentLinkClick);
  eventUI.bind('click', 'div.comment-box div.comment_list a.show-all-comments', onShowAllCommentsClick);
  eventUI.bind('keyup', '#edit-comment-wrapper textarea', _.debounce(onTextAreaKeyupAutolinking, 500), true);
  eventUI.bind('keydown', '#edit-comment-wrapper textarea', onTextAreaKeydown, true);
  eventUI.bind('click', '.comment-box .overflow-control', onShowOverflowClicked);
  eventUI.bind('click', '.comment-box.realtime-layout .comment-like', onLikeCommentClicked);

  return {
    setupCommentBox: setupCommentBox,
    signals: signals
  };

});

